<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Jockey from './plugins/jockey/jockey'

export default {
  name: 'App',
  created(){
    //Super App 内设置分享功能
    if(navigator.userAgent.indexOf('SuperApp') !== -1){
      Jockey.send("setNaviMenu", {
        "menus":[
            {
              "position":"right",
              "event":"onShareClick",
              "title":"分享",
              "titleColor":"#052F6D",
              "iconId":"icon_navi_share"
            }
        ]
      });
      Jockey.on("onShareClick", () => {
        Jockey.send("shareContent", {
          "title": "有鱼新股表现榜",
          "desc" : "新股表现 尽收眼底",
          "platform": 0,
          "type":0,
          "url": window.location.href
        });
      });
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@300;400;500;700&display=swap');
@font-face {
    font-family: "DINAlternate";
    src: url("./assets/fonts/DIN-Medium/DIN-Medium.woff") format("woff"), 
    url("./assets/fonts/DIN-Medium/DIN-Medium.ttf") format("truetype"), 
    url("./assets/fonts/DIN-Medium/DIN-Medium.svg#DIN-Bold") format("svg"); 
    font-style: normal;
    font-weight: normal;
}

* {
  margin: 0;
  padding: 0;
}

#app {
  margin:auto;
  max-width: 7.50rem;
  min-height: 100vh;
  overflow: hidden;
  background: #0d37a2;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: .24rem;
  color: #3E4171;
}

</style>
